import React from 'react';
import { Box } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PaginaSuscripcion from '../components/suscripcion/PaginaSuscripcion';
import TarjetaAU from '../components/suscripcion/TarjetaAU';
import EtiquetaAU from '../components/suscripcion/EtiquetaAU';
import LineaDeTiempo from '../components/suscripcion/LineaDeTiempo';
import BotonAU from '../components/suscripcion/BotonAU';
import CirculoIcono from '../components/suscripcion/CirculoIcono';
import { enlaceWhatsApp, ENLACE_GRUPO_WHATSAPP } from '../utils/whatsapp';
import { AU, FUENTE } from '../styles/tokensAU';

const HITOS = [
  { titulo: 'Día 3', detalle: 'Te entrego el programa y hacemos el onboarding.' },
  { titulo: 'Día 4', detalle: 'Empiezas a entrenar.' },
];

// Lo mismo que se le cuenta a la persona en el paso 1, sin prometer nada más (ni acceso a la app).
const WelcomePage = () => (
  <PaginaSuscripcion>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, textAlign: 'center', pt: 2 }}>
      <CirculoIcono><CheckRoundedIcon /></CirculoIcono>
      <Box component="h1" sx={{ m: 0, fontFamily: FUENTE, fontSize: 26, fontWeight: 800, lineHeight: 1.15, color: AU.oscuro }}>
        ¡Bienvenido a AU Coaching Services!
      </Box>
      <Box sx={{ fontFamily: FUENTE, fontSize: 16, fontWeight: 600, color: AU.azulHover }}>
        Tu camino hacia una mejor versión de ti mismo comienza hoy.
      </Box>
    </Box>

    <TarjetaAU>
      <EtiquetaAU component="h2" sx={{ m: 0 }}>Qué pasa ahora</EtiquetaAU>
      <Box sx={{ my: 1.5, fontFamily: FUENTE, fontSize: 14, color: AU.oscuro }}>
        Los días cuentan desde tu fecha de contratación.
      </Box>
      <LineaDeTiempo hitos={HITOS} />
    </TarjetaAU>

    <TarjetaAU>
      <EtiquetaAU component="h2" sx={{ m: 0 }}>Únete al grupo</EtiquetaAU>
      <Box sx={{ mt: 1.5, mb: 2, fontFamily: FUENTE, fontSize: 14, color: AU.oscuro }}>
        Entra al grupo de AU Coaching y preséntate: cuéntanos tu nombre y tu objetivo.
      </Box>
      <BotonAU component="a" href={ENLACE_GRUPO_WHATSAPP} target="_blank" rel="noopener noreferrer">
        Unirme al grupo de WhatsApp
      </BotonAU>
    </TarjetaAU>

    <Box sx={{ textAlign: 'center', fontFamily: FUENTE, fontSize: 15, color: AU.grisMedio }}>
      Con disciplina y constancia, alcanzarás todos los objetivos que te propongas.
    </Box>

    <BotonAU component="a" href={enlaceWhatsApp()} target="_blank" rel="noopener noreferrer" variante="secundario">
      Escríbenos por WhatsApp
    </BotonAU>
  </PaginaSuscripcion>
);

export default WelcomePage;
